import React from 'react';
import './style.scss';
import Tracker from '../../../genesys/tracker';
import CloseIcon from '../../../common/icons/close.svg';
import { DISPLAY } from '../../main/types';
import { LAYERS } from '../../layers/types';
import * as MainActions from '../../main/actions';

export default class PopupFrame extends React.Component {
    constructor(props) {
        super(props);

        this.showAfter = props.delays && props.delays.showAfter ? props.delays.showAfter : 0;
        this.hideAfter = props.delays && props.delays.hideAfter ? props.delays.hideAfter : 0;
        this.componentTimeout = null;
        this.state = {
            visibility: 'hidden'
        };
    }

    componentDidMount() {
        if (this.showAfter > 0) {
            this.componentTimeout = setTimeout(() => this.show(), this.showAfter * 1000);
        } else {
            this.show();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.componentTimeout);
    }

    show() {
        this.setState({ visibility: 'visible' });
        if (this.hideAfter > 0) {
            this.componentTimeout = setTimeout(() => this.hide(), this.hideAfter * 1000);
        }

        MainActions.updateMainLayer({
            layer: LAYERS.POPUP,
            iFrameMode: DISPLAY.FULLSCREEN,
            source: 'popupFrame'
        });
    }

    hide() {
        Tracker.timeOutInvite();
        this.props.events.close();
    }

    onClick(e) {
        if (e.target.id == 'popup-view' && this.props.events.outsideClick) {
            this.props.events.outsideClick();
        }
    }

    render() {
        const { events, theme, children, language } = this.props;

        return (
            <div
                id="popup-view"
                className={`${this.state.visibility} popup-view`}
                onClick={(e) => this.onClick(e)}
            >
                <div className={`${theme} content`}>
                    <div className="close">
                        <a
                            href="#"
                            title={language && language === 'en' ? 'Close' : 'Zamknij'}
                            onClick={events.close}
                            className="icon icon-close"
                            tabIndex={1}
                        >
                            <CloseIcon />
                        </a>
                    </div>
                    <div className="container">{children}</div>
                </div>
            </div>
        );
    }
}
